import React, {useEffect, useState} from "react";
import {Typography} from "@mui/material";
import DraggableDialog from "../../../../components/dialog/DraggableDialog";
import {doc, onSnapshot, deleteDoc} from "firebase/firestore";
import {db} from "../../../../config/firebase";
import RecursiveTable from "../../../../components/table/RecursiveTable";
import BasicTabs from "../../../../components/tabs/BasicTabs";
import {DebugIdAtom} from "../../dashboard/atoms";
import {useAtomValue} from "jotai";

export const Debugger = ({open, updatePosition}) => {
  const debugId = useAtomValue(DebugIdAtom);
  const [debug, setDebug] = useState(null);

  useEffect(() => {
    console.log("Debug ID", debugId);
    if (debugId) {
      const unsubscribe = onSnapshot(doc(db, "debug", debugId), (doc) => {
        const debugData = doc.data();
        console.log("Debug update: ", debugData);

        setDebug(debugData);
        updatePosition(debugData?.position?.origin_id || debugData?.position?.id)
      });

      return () => {
        unsubscribe()
        deleteDoc(doc(db, "debug", debugId))
          .then(() => {
            console.log("debug deleted")
          })
          .catch(error => {
            console.log("debug saved", error)
          })
      };
    }

  }, [debugId]);

  const getContent = (key, value) => {
    if (typeof value === "string") {
      return <RecursiveTable data={{[key]: value}} />
    }
    if (key === "control") {
      return <RecursiveTable data={value} />
    }
    if (key === "params" && value) {
      return Object.entries(value).map(([k, v]) => <RecursiveTable title={k} data={v} />)
    }
    return null;
  }

  return (
    <DraggableDialog
      open={open && !!debug}
    >
      {
        debug ?
        <BasicTabs
          tabs={["Control", "Params"]}
          tabContents={[getContent("control", debug["control"]), getContent("params", debug["params"])]}
        />
        :
        <Typography>Debug data not found</Typography>
      }
    </DraggableDialog>
  )
}